//@flow
import * as React from 'react';
import classnames from 'classnames';
import { themr } from 'react-css-themr';
import { IconWithPopover } from 'common/components/core/icon';
import { PopoverTriggerEnum } from 'common/components/core/popover/popOverFactory';

import theme from './HelpTooltip.scss';

type Props = {
    className?: string,
    tooltipText: string,
    preferPlace: string
};

class HelpTooltip extends React.Component<Props> {
    render() {
        const { tooltipText, className, preferPlace } = this.props;
        return (
            <IconWithPopover
                theme={theme}
                className={classnames(theme.helpIcon, {
                    [className]: !!className
                })}
                icon={'help-support'}
                triggerPopoverOn={PopoverTriggerEnum.Hover}
                popOverContent={tooltipText}
                preferPlace={preferPlace || 'right'}
                popOverClassName={theme.popOver}
            />
        );
    }
}

export default themr(null, theme)(HelpTooltip);
